
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { createAdmin } from '@/api/admin'
import { stringArrayToString, stringToStringArray } from '@/filters'
import { isValidUsername } from '@/utils/validate'
import { Form as ElForm } from 'element-ui'
import { adminRules } from '@/utils/rules'
@Component({
  name: 'addAdmin',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) private enterpriseInfo!: any
  private infoForm: any = {
    username: '',
    email: '',
    ip_address: ['0.0.0.0'],
    password: '',
    available_currency: [],
    google_code: '',
    description: '',
    manager_type: '',
  }
  private availableCurrency: any = []
  private capsTooltip = false
  private ip_address: string = ''
  private loading = false
  private rules = adminRules

  private changeInput(e: any) {
    e.target.value = e.target.value.replace(
      /[`~!@#$%^&*()_\-+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
      ''
    )
  }

  // 编辑IP地址相关操作
  private openIpEdit: boolean = false
  private editIpAddress() {
    this.openIpEdit = true
  }
  private onAdd() {
    this.infoForm.ip_address.push('')
  }
  private onDel(i) {
    this.infoForm.ip_address.splice(i, 1)
  }
  private editIp() {
    this.infoForm.ip_address = this.infoForm.ip_address.filter((item) => {
      return item !== ''
    })
    this.openIpEdit = false
  }
  @Watch('infoForm.ip_address')
  private watchIp(i) {
    this.ip_address = stringArrayToString(i)
  }

  created() {
    this.ip_address = stringArrayToString(this.infoForm.ip_address)
  }

  private managerChange() {
    this.infoForm.available_currency = []
    if (this.infoForm.manager_type === 'admin') {
      this.infoForm.available_currency =
        this.$store.state.app.enterprise.available_currency
    }
  }

  private checkCapslock(e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip =
      key !== undefined &&
      key !== null &&
      key.length === 1 &&
      key >= 'A' &&
      key <= 'Z'
  }

  private ipAddressChange(e: any) {
    this.infoForm.ip_address = stringToStringArray(e)
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          await createAdmin(this.infoForm).then(() => {
            this.$message({
              message: 'Create successful!',
              type: 'success',
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }
}
